import logoPrincipal from '@assets/atemporal/logoAtemporalCli.svg'
// TEMPORAL (solicitud del usuario): menú de usuario oculto — restaurar import al reactivar (Atemporal 1b53e192)
// import usuarioIcono from '@assets/nuevos-iconos/usuario.png'
import { Spinner } from '@components/Loaders/spinner'
import { useUser } from '@context/user'

import * as Select from '@radix-ui/react-select'
// TEMPORAL (solicitud del usuario): menú de usuario oculto — restaurar al reactivar (Atemporal 1b53e192)
// import * as Tooltip from '@radix-ui/react-tooltip'
import { useTopbarPrecioTotal } from '@hooks/useTopbarPrecioTotal'
import { createRootUrl } from '@proxies/index'
import { useAppStore } from '@store'
import { ui } from '@utils/i18n/uiCopy'
import { DesignerInfo, Store } from '@types'
// import capitalize from '@utils/conversion/capitalize'
import clsx from 'clsx'
// import { motion } from 'framer-motion'
import React, { forwardRef, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ConfirmationSaveStore from './ConfirmationSaveStore'
// import ModifyData from './ModifyData'
// import PopupMenu from './popUp'

export const SelectItem = forwardRef<HTMLDivElement, { children: React.ReactNode; value: string }>(
  ({ children, value, ...props }, forwardedRef) => {
    return (
      <Select.Item
        {...props}
        value={value}
        ref={forwardedRef}
      >
        <Select.ItemText>{children}</Select.ItemText>
      </Select.Item>
    )
  },
)
SelectItem.displayName = 'SelectItem'
export function Topbar() {
  const prefs = useAppStore.use.prefs()
  const clientInfo = useAppStore.use.clientInfo()
  const navigate = useNavigate()
  const projectOpened = useAppStore((store) => store.clientInfo.nombreProyecto)
  const isProjectOpened = useAppStore((store) => store.isProjectOpened)
  // TEMPORAL (solicitud del usuario): menú de usuario oculto (Atemporal 1b53e192)
  // const openModal = useAppStore.use.openModal()
  const isModalOpen = useAppStore((s) => s.isModalOpen)
  const { user } = useUser()
  // TEMPORAL (solicitud del usuario): menú de usuario oculto — localName solo se usaba ahí
  // const [localName, setLocalName] = useState('')
  const toggleNonBaseLights = useAppStore.use.toggleNonBaseLights()
  const [showSpinner, setShowSpinner] = useState(false)
  const [spinnerMessage, setSpinnerMessage] = useState('')
  const [isTogglingLights, setIsTogglingLights] = useState(false)
  const [currentMessage, setCurrentMessage] = useState('')
  const tipoUsuario = useAppStore((s) => s.tipoUsuario)
  const esMio = useAppStore((s) => s.esMio)
  const [showPermError, setShowPermError] = useState(false)
  const [showProyectError, setShowProyectError] = useState(false)

  const [emailModalState, setEmailModalState] = useState<'none' | 'confirm' | 'success'>('none')
  const [missingDataMessage, setMissingDataMessage] = useState('')
  const [showMissingDataModal, setShowMissingDataModal] = useState(false)

  const { precioTotalValue, formatNumber } = useTopbarPrecioTotal()

  const disenadorActual = clientInfo?.disenadorActual ?? null
  const disenadorOriginal = clientInfo?.disenadorOriginal ?? null
  // const hasDifferentOriginal =
  //   !!disenadorOriginal &&
  //   (!disenadorActual || disenadorOriginal.idUsuarios !== disenadorActual.idUsuarios)
  const normalizedUserName = user?.nombre?.trim().toLowerCase()
  const normalizedManagerName = disenadorActual?.nombre?.trim().toLowerCase()
  const showCreatorChip = Boolean(disenadorOriginal)
  const showManagerChip =
    Boolean(disenadorActual) &&
    (!normalizedManagerName || normalizedManagerName !== normalizedUserName || showCreatorChip)
  const shouldShowDesignerChips = showCreatorChip || showManagerChip

  const positionLogo = 'ml-4 mt-1'
  // Usar logoPrincipal assets cuando la API sea pf032api.for2home.com, sino usar el logo de prefs
  const apiUrl = createRootUrl()
  const isAtemporalApi = apiUrl.includes('pf032api.for2home.com')
  const logoToUse = isAtemporalApi ? logoPrincipal : prefs?.ICONOCLIPRINCIPAL
  const topbarBg = 'bg-white'
  const textClass = 'text-C/Color3'

  const renderDesignerChip = (label: string, designer: DesignerInfo | null) => {
    if (!designer) return null
    const textColor = 'text-C/Color3'
    const labelClass = clsx('mr-2 max-w-[120px] truncate text-base font-normal', textClass)
    const nameClass = clsx('mr-4 max-w-[140px] truncate text-base font-semibold', textColor)
    const emailClass = clsx('max-w-[160px] truncate text-xs font-extralight opacity-80', textColor)
    return (
      <div className={clsx('flex h-full w-full items-center text-sm', textColor)}>
        <strong className={labelClass}>{label}:</strong>
        <span className={nameClass}>{designer.nombre || '-'}</span>
        <span className={emailClass}>{designer.correo || '-'}</span>
      </div>
    )
  }

  // TEMPORAL (solicitud del usuario): menú de usuario oculto — loadUserData solo alimentaba el nombre del menú (Atemporal 1b53e192)
  // const loadUserData = () => {
  //   const storedUserData = localStorage.getItem('userData')
  //   if (storedUserData) {
  //     const userData = JSON.parse(storedUserData) as { name?: string }
  //     setLocalName(userData.name || 'Usuario')
  //   }
  // }

  // useEffect(() => {
  //   loadUserData()
  //   const handleStorageChange = () => {
  //     loadUserData()
  //   }
  //   window.addEventListener('storage', handleStorageChange)
  //   const intervalId = setInterval(loadUserData, 1000)
  //   return () => {
  //     window.removeEventListener('storage', handleStorageChange)
  //     clearInterval(intervalId)
  //   }
  // }, [])

  useEffect(() => {
    if (isTogglingLights) {
      setShowSpinner(true)
      setSpinnerMessage(currentMessage)
    } else {
      setShowSpinner(false)
    }
  }, [isTogglingLights, currentMessage])

  // TEMPORAL (solicitud del usuario): menú de usuario oculto — restaurar estado al reactivar (Atemporal 1b53e192)
  // const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)
  // const [isModifyDataOpen, setIsModifyDataOpen] = useState(false)

  const handleConfirmEmail = () => {
    setEmailModalState('success')
  }

  return (
    <>
      {showSpinner && <Spinner msg={spinnerMessage} />}
      <aside
        className={clsx(
          ` relative left-0 top-0 z-0 w-full items-end ${topbarBg} h-20 pb-4 `,
          'bg-gradient-to-r from-white/80 via-white/60 to-white/40 backdrop-blur-sm',
        )}
      >
        <div className='relative flex h-16 items-center justify-between pt-2'>
          {/* Logo a la izquierda */}
          <div className='flex items-center'>
            {logoToUse && (
              <img
                onClick={() => !isModalOpen && navigate('/planner')}
                className={clsx(
                  positionLogo,
                  !isModalOpen && 'cursor-pointer',
                  'h-11 max-h-none w-auto antialiased',
                )}
                src={logoToUse}
                alt='Logo'
              />
            )}
          </div>

          {/* Precio y nombre del proyecto a la derecha (antes del TexturesPanel) */}
          <div className='absolute right-28 top-12 flex -translate-y-1/2 flex-col items-end text-sm'>
            {isProjectOpened && projectOpened ? (
              <div className={clsx('mb-1 cursor-default text-sm laptop:text-base', textClass)}>
                <span className={clsx('mr-1 font-semibold', textClass)}>{'Proyecto:'}</span>
                <span className={clsx(textClass)}>{projectOpened}</span>
              </div>
            ) : null}
            {precioTotalValue > 0 ? (
              <div
                className={clsx(
                  'flex cursor-default flex-row items-center font-semibold laptop:text-base',
                  textClass,
                )}
                aria-live='polite'
              >
                <span className={clsx('mr-2', textClass)}>{ui('total')}</span>
                <span className={clsx('ml-0', textClass)}>{formatNumber(precioTotalValue)} €</span>
              </div>
            ) : null}
          </div>

          {/* TEMPORAL (solicitud del usuario): menú de usuario oculto en desktop (Atemporal 1b53e192).
              Restaurar este bloque + PopupMenu/ModifyData al pie cuando se reactive. */}
          {/*
          <div className='absolute right-7 top-11 flex -translate-y-1/2'>
            <div className='flex flex-col items-center gap-1'>
              <Tooltip.Provider>
                <Tooltip.Root>
                  <Tooltip.Trigger asChild>
                    <motion.div
                      whileHover={{ scale: isModalOpen ? 1 : 1.1 }}
                      whileTap={{ scale: isModalOpen ? 1 : 0.9 }}
                      className={clsx(
                        !isModalOpen ? 'cursor-pointer' : 'cursor-default',
                        'flex h-10 w-10 items-center justify-center rounded-full transition-all duration-200',
                        !isModalOpen && 'border border-black/10 hover:bg-black/5',
                        'bg-white/50',
                      )}
                      onClick={(e) => {
                        e.stopPropagation()
                        if (!isModalOpen) {
                          if (!window.localStorage.getItem('isUserLogged')) {
                            openModal()
                            navigate('/planner/login')
                          } else {
                            setIsUserMenuOpen(!isUserMenuOpen)
                          }
                        }
                      }}
                      role='button'
                    >
                      <img
                        src={usuarioIcono}
                        className='h-6 w-6'
                        alt={"Menú usuario"}
                      />
                    </motion.div>
                  </Tooltip.Trigger>
                  <Tooltip.Content
                    side='left'
                    align='center'
                    className='z-50 rounded bg-C/Color1 p-2 text-base font-normal leading-4 text-C/Color5 outline outline-[0.5px] outline-C/Color3'
                  >
                    {"Menú usuario"}
                    <Tooltip.Arrow className='fill-C/Color1' />
                  </Tooltip.Content>
                </Tooltip.Root>
              </Tooltip.Provider>
              <p
                className={clsx('cursor-pointer text-sm font-medium', textClass)}
                onClick={(e) => {
                  e.stopPropagation()
                  if (!isModalOpen) {
                    if (!window.localStorage.getItem('isUserLogged')) {
                      openModal()
                      navigate('/planner/login')
                    } else {
                      setIsUserMenuOpen(!isUserMenuOpen)
                    }
                  }
                }}
              >
                {capitalize(user.nombre)}
              </p>
            </div>
          </div>
          */}

          {/* Chips de diseñadores a la derecha */}
          {shouldShowDesignerChips && (
            <div
              className='absolute right-8 top-1/2 flex -translate-y-1/2 items-center gap-3'
              style={{ transform: 'translateY(-50%) translateX(0)' }}
            >
              {showCreatorChip && (
                <div
                  className={clsx(
                    'flex max-h-8 max-w-96 items-center justify-start rounded-lg px-4 py-2 shadow-sm transition-colors duration-200',
                    'bg-black/5 text-C/Color3 ring-1 ring-black/10 hover:bg-black/10',
                  )}
                >
                  {renderDesignerChip('Creador', disenadorOriginal)}
                </div>
              )}
              {showManagerChip && (
                <div
                  className={clsx(
                    'flex max-h-8 max-w-96 items-center justify-start rounded-lg px-4 py-2 shadow-sm transition-colors duration-200',
                    'bg-black/5 text-C/Color3 ring-1 ring-black/10 hover:bg-black/10',
                  )}
                >
                  {renderDesignerChip('Gestor', disenadorActual)}
                </div>
              )}
            </div>
          )}
        </div>
        {/* <div className='absolute left-0 top-14 mt-3 h-1 w-full bg-C/ColorF11'></div> */}
        <ConfirmationSaveStore
          isOpen={showPermError}
          onClose={() => setShowPermError(false)}
          onConfirm={() => setShowPermError(false)}
          nombre={user?.nombre || ''}
          mode='success'
          message={'Este usuario no tiene permiso de edición'}
        />
        <ConfirmationSaveStore
          isOpen={showProyectError}
          onClose={() => setShowProyectError(false)}
          onConfirm={() => setShowProyectError(false)}
          nombre={user?.nombre || ''}
          mode='success'
          message={'No se puede modificar un diseño que no sea tuyo'}
        />
        {emailModalState !== 'none' && (
          <ConfirmationSaveStore
            key={`email-modal-${emailModalState}`}
            isOpen={true}
            onClose={() => setEmailModalState('none')}
            onConfirm={
              emailModalState === 'confirm' ? handleConfirmEmail : () => setEmailModalState('none')
            }
            nombre={user?.nombre || ''}
            mode={emailModalState === 'confirm' ? 'confirm' : 'success'}
            message={
              emailModalState === 'confirm'
                ? '¿Deseas enviar este proyecto a TPC Cocinas para su revisión? '
                : emailModalState === 'success'
                  ? 'Tu proyecto se ha enviado a TPC'
                  : ''
            }
            autoCloseMs={undefined}
          />
        )}
        {/* Modal específico para datos faltantes - NO se cierra automáticamente */}
        {showMissingDataModal && (
          <ConfirmationSaveStore
            key='missing-data-modal'
            isOpen={true}
            onClose={() => setShowMissingDataModal(false)}
            onConfirm={() => setShowMissingDataModal(false)}
            nombre={user?.nombre || ''}
            mode='success'
            message={missingDataMessage}
            autoCloseMs={undefined}
          />
        )}
      </aside>
      {/* TEMPORAL (solicitud del usuario): menú de usuario oculto — restaurar PopupMenu + ModifyData al reactivar (Atemporal 1b53e192) */}
      {/*
      {window.localStorage.getItem('isUserLogged') && (
        <PopupMenu
          isOpen={isUserMenuOpen}
          onClose={() => setIsUserMenuOpen(false)}
          onModifyDataClick={() => {
            setIsModifyDataOpen(true)
            setIsUserMenuOpen(false)
          }}
        />
      )}
      {isModifyDataOpen && (
        <ModifyData
          onClose={() => setIsModifyDataOpen(false)}
          hideTrigger={true}
        />
      )}
      */}
    </>
  )
}
